import { render, staticRenderFns } from "./IndexCompra.vue?vue&type=template&id=1fa633fd&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./IndexCompra.vue?vue&type=style&index=0&id=1fa633fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa633fd",
  null
  
)

export default component.exports